/* eslint-disable import/first */
import React, { useEffect, useState } from 'react';
import ClassNames from 'classnames';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useIntl } from 'react-intl';
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight';
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import HeroBanner from '../HeroBanner';
import MediaGrid from '../MediaGrid';
import MediaList from '../MediaList';
import BannerMedium from '../BannerMedium';
import EasyOrder from '../EasyOrder';
import EasyOrderDesktop from '../EasyOrderDesktop';
import CurrentOrder from '../CurrentOrder';
import CurrentOrderDesktop from '../CurrentOrderDesktop';
import ProductsList from '../ProductsList';
import Video from '../Video';
import css from './index.module.scss';
import { navigate } from '@reach/router';
import { viewAllGA } from 'spwa-ui-library/esm/utils/helperGA';
import bestSellerIcon from './images/best-sellers.svg';
import exploreMenuIcon from './images/explore-menu.png';
import exclusiveDealsIcon from './images/exclusive-offers.png';
// import easyReorderIcon from './images/easy-reorder.png';
import topDealsIcon from './images/top-picks.svg';
import contactLessIcon from './images/contactless-delivery.png';

export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase()?.replace(/\s/g, '-'));
const { selectDesktop } = Slices.appSlice;
const { selectFirstCategory } = Slices.categorySlice;
const { selectCountryValidations, getClusterId } = Slices.configSlice;
const { getPreviousOrders, getCurrentOrders, selectCurrentOrders } = Slices.orderSlice;
const { selectFirstMenu } = Slices.menuSlice;
const { fetchProductsByCategoryId } = Slices.productSlice;

let previouslyOrderedWait = null;
let previouslyOrderedWait2 = null;
export default function ContentSection({ widgetData, children }) {
  const intl = useIntl();
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const menu = useSelector(selectFirstMenu);
  const firstCategory = useSelector(selectFirstCategory);
  const clusterId = useSelector(getClusterId);
  const [defaultMenuPath, setDefaultMenuPath] = useState(null);
  const profile = useSelector((state) => state.profile);
  const allCurrentOrders = useSelector(selectCurrentOrders);
  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, profile.country)
  );
  const [orders, setOrders] = React.useState([]);
  let loadBanner = false;
  const [allStatus, setAllStatus] = React.useState('initial');
  const isDesktop = useSelector(selectDesktop);
  const { id, title, ctaAction, widgetType, products } = widgetData;
  const componentsToRender = [];
  let fullWidth = false;
  let showTitleArea = true;
  if (!title && !ctaAction.length) {
    showTitleArea = false;
  }

  let caseNull = false;
  let icon = '';

  useEffect(() => {
    if (
      widgetType === 'HOME_TRACKORDER_BASIC' &&
      allStatus === 'initial' &&
      auth.isLoggedIn &&
      auth.status === 'succeeded'
    ) {
      clearTimeout(previouslyOrderedWait2);
      previouslyOrderedWait2 = setTimeout(() => {
        dispatch(getCurrentOrders({ page: 1 })).then((res) => {
          setOrders(res?.payload?.data?.data?.list);
          // setOrders([]);
        });
      });

      setAllStatus('loaded');
    }
    if (
      widgetType === 'REORDER_BASIC' &&
      allStatus === 'initial' &&
      auth.isLoggedIn &&
      auth.status === 'succeeded'
    ) {
      clearTimeout(previouslyOrderedWait);
      previouslyOrderedWait = setTimeout(() => {
        dispatch(getPreviousOrders({ page: 1 })).then((res) => {
          const orderListEasy = res?.payload?.data?.data?.list?.filter(
            (itm) =>
              countryValidations.defaultMenuTempId === itm.menuTemplateId &&
              countryValidations.defaultMenuId === itm.menuId
          );
          setOrders(orderListEasy);
        });
        setAllStatus('loaded');
      }, 1700);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const path = generateCategoryRoute({ category: firstCategory, locale: intl.locale });
    setDefaultMenuPath(path);
  }, [firstCategory, intl.locale]);

  if (
    products.length === 0 &&
    (widgetType === 'BEST_SELLERS_WITHOUT_PRICE' ||
      widgetType === 'BEST_SELLERS' ||
      widgetType === 'WHATS_NEW')
  ) {
    return null;
  }

  function hasDeliveredStatus(items = []) {
    if (!Array.isArray(items)) {
      return false;
    }

    for (const item of items) {
      if (item?.status === 'DELIVERED') {
        return true;
      }
    }

    return false;
  }
  const passOrderArr = orders?.length > 0 ? orders : allCurrentOrders || [];
  const isCurrentOrderWidgetHide = hasDeliveredStatus(passOrderArr);
  if (
    widgetType === 'HOME_TRACKORDER_BASIC' &&
    auth.isLoggedIn &&
    auth.status === 'succeeded' &&
    isCurrentOrderWidgetHide &&
    !isDesktop
  ) {
    return null;
  }

  // if (
  //   widgetType === 'REORDER_BASIC' &&
  //   auth.isLoggedIn &&
  //   auth.status === 'succeeded' &&
  //   isCurrentOrderWidgetHide
  // ) {
  //   return null;
  // }

  switch (widgetType) {
    case 'BANNER_LARGE':
      icon = exclusiveDealsIcon;
      componentsToRender.push(HeroBanner);
      break;
    case 'BANNER_LARGE_305x158':
      icon = exclusiveDealsIcon;
      componentsToRender.push(HeroBanner);
      break;
    case 'HOME_TRACKORDER_BASIC':
      icon = widgetData.title_icon;
      if (isDesktop) {
        componentsToRender.push(CurrentOrderDesktop);
      } else {
        componentsToRender.push(CurrentOrder);
      }
      break;

    case 'EXPLORE_MENU':
      icon = widgetData.title_icon;
      componentsToRender.push(MediaGrid);

      break;
    // case 'BEST_SELLERS_WITHOUT_PRICE':
    //   icon = widgetData.title_icon;
    //   componentsToRender.push(ProductsList);
    //   break;
    case 'BEST_SELLERS':
    case 'WHATS_NEW':
    case 'BEST_SELLERS_WITHOUT_PRICE':
      icon = widgetData.title_icon;
      componentsToRender.push(ProductsList);
      break;
    // case 'WHATS_NEW':
    //   icon = widgetData.title_icon;
    //   componentsToRender.push(ProductsList);
    //   break;
    case 'REORDER_BASIC':
      icon = widgetData.title_icon;
      if (isDesktop) {
        componentsToRender.push(EasyOrderDesktop);
      } else {
        componentsToRender.push(EasyOrder);
      }
      // icon = easyReorderIcon;
      break;
    case 'BANNER_MEDIUM':
      icon = widgetData.title_icon;
      componentsToRender.push(BannerMedium);
      loadBanner = true;
      break;
    case 'CONTACTLESS_DELIVERY':
      icon = widgetData.title_icon;
      componentsToRender.push(MediaList);
      break;
    case 'BANNER_SMALL':
      componentsToRender.push(BannerMedium);
      fullWidth = true;
      loadBanner = true;
      break;
    case 'BANNER_VIDEO':
      // componentsToRender.push(Video);
      loadBanner = true;
      break;
    default:
      caseNull = true;
      break;
  }

  let showTitle = true;
  let hidetitle = true;
  if (isDesktop && (widgetType === 'BANNER_LARGE' || widgetType === 'BANNER_LARGE_305x158')) {
    hidetitle = false;
  }
  if (!showTitle || caseNull) {
    return null;
  }

  if (isDesktop && loadBanner) {
    return '';
  }

  if (
    (!auth.isLoggedIn && widgetType === 'REORDER_BASIC') ||
    (!auth.isLoggedIn && widgetType === 'HOME_TRACKORDER_BASIC')
  ) {
    return null;
  }
  if (
    (!orders?.length && widgetType === 'REORDER_BASIC') ||
    (!countryValidations?.enableReorder && widgetType === 'REORDER_BASIC')
  ) {
    return null;
  }
  if (!orders?.length && widgetType === 'HOME_TRACKORDER_BASIC') {
    return null;
  }

  const clickViewAll = (event, path) => {
    event.preventDefault();
    navigate(path);
    viewAllGA();
    dispatch(
      fetchProductsByCategoryId({
        id: firstCategory?.id,
        cluster: clusterId,
        Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
      })
    );
  };
  return (
    <>
      <section className={ClassNames(css.root, widgetType, { fullWidth: fullWidth })}>
        {showTitleArea && showTitle && widgetType !== 'REORDER_BASIC' ? (
          <div className={css.titleArea}>
            {title && hidetitle ? (
              <div className={css.heading}>
                <h2 className={css.title}>{title}</h2>
                {icon && <img src={icon} alt={title} width="18" />}
              </div>
            ) : (
              ''
            )}
            {ctaAction && ctaAction.length ? (
              <>
                {ctaAction.map(
                  (cta) =>
                    cta.title && (
                      <a
                        className={css.cta}
                        key={id}
                        href={defaultMenuPath}
                        onClick={(event) => clickViewAll(event, defaultMenuPath)}
                      >
                        <span>{cta.title}</span>
                        <FaArrowRight className={css.arrowrighticon} />
                      </a>
                    )
                )}
              </>
            ) : (
              ''
            )}
          </div>
        ) : (
          ''
        )}
        {componentsToRender.map((Comp) => {
          return (
            <Comp
              key={`${id}_comp`}
              orders={orders}
              widgetData={widgetData}
              viewAllMenu={(event) => clickViewAll(event, defaultMenuPath)}
            />
          );
        })}
        {children}
      </section>
      {widgetType === 'BANNER_LARGE' && isDesktop && <div className={css.largeBannerSpacing} />}
    </>
  );
}
